import React, {useState} from "react";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography
} from "@mui/material";
import {post} from "../../api/api";
import {useAppStore} from "../../store/appStore";
import {showMessage} from "../../utils/snackbar";

const UsageInstructions: React.FC = () => {
    const [checked, setChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onAgree = async () => {
        setIsSubmitting(true)
        try {
            const userModel = await post("/me/usage-instructions");
            useAppStore.setState({userModel});
        } catch (error) {
            console.warn("Failed to accept usage instructions: ", error);
        } finally {
            setIsSubmitting(false)
        }
    };

    return (
        <Dialog open={true} maxWidth="md" fullWidth>
            <DialogTitle>Algemene instructies voor het veilig gebruik van AI</DialogTitle>
            <DialogContent dividers>

                <Typography variant="h6" mt='24px'>Vraag toestemming</Typography>
                <Typography variant="body2" component="p">
                    Informeer deelnemers (cliënten, patiënten en andere deelnemers) altijd over het gebruik van AI.
                    Vraag expliciete toestemming voordat je AI gebruikt voor transcriberen of andere verwerking van
                    gegevens.
                </Typography>

                <Typography variant="h6" mt='24px'>Controleer je verslagen zorgvuldig</Typography>
                <Typography variant="body2" component="p">
                    AI gegenereerde informatie kan fouten of onvolledigheden bevatten. Je bent zelf verantwoordelijk
                    voor de correctheid van de verslagen. Controleer je verslagen zorgvuldig.
                </Typography>

                <Typography variant="h6" mt='24px'>Informatiebeveiliging</Typography>
                <Typography variant="body2" component="p">
                    Volg het informatiebeveiligingsbeleid van je werkgever. Meld eventuele zorgen of problemen direct en
                    deel nooit inloggegevens met anderen, ook niet met Medendo.
                </Typography>

                {/* --- Template Wizard Instructions Section --- */}
                <Typography variant="h6" mt='32px'>Houd templates anoniem</Typography>
                <Typography variant="body2" component="p" gutterBottom>
                    Templates bepalen hoe je verslag eruit ziet. Ze mogen geen informatie bevatten die direct of indirect herleidbaar is tot een specifiek persoon. Controleer dus zorgvuldig of je templates anoniem zijn, ook wanneer ze met behulp van AI zijn gemaakt.
                </Typography>

            </DialogContent>
            <DialogActions>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={checked}
                            onChange={(e) => setChecked(e.target.checked)}
                            name="accept"
                        />
                    }
                    label="Ik heb de algemene instructies gelezen en begrepen"
                />
                <Button onClick={onAgree} disabled={!checked || isSubmitting} variant="contained" color="primary">
                    Akkoord
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UsageInstructions;
